export default __webpack_public_path__ + "static/media/hotelSvg.2a9b0f82.svg";